import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { routes } from "../../helpers/constants";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { notify } from "../../helpers/commonFunctions";
import { EyeHideIcon, EyeShowIcon, BackArrowIcon, emailIcon } from "../../assets/icons";
import Loader from "../../components/Loader";
import LoginLeftBg from "../../assets/images/login-left-bg.png";
import LoginRightBottomBg from "../../assets/images/Right-bottom.png";
import LoginRightTopBg from "../../assets/images/login-right-top-bg.png";
import signLogo from "../../assets/images/signLogo.png";
// import checkboxChecked from "../../assets/images/checkboxChecked.svg";
import forgotPassword1 from "../../assets/images/forgot-password1.png";
import lockPassword from "../../assets/images/forgot-password1.png";
import Celebration from "../../assets/images/bubble-chat.svg";
import { logout } from "../../redux/slices.js/admins/adminsSlice";
import {
  reqToResetPassword,
  setLoginSource,
} from "../../redux/slices.js/authentication/authenticationSlice";
import { passwordSchema } from "../../Validations/AuthValidation";
import Modal from "../../components/Modal";

const ResetPassword = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const initialValues = {
    password: "",
    confirmPassword: "",
    rememberMe: false,
  };
  const forgotEmail = localStorage.getItem("forgotEmail");

  const getPasswordStrength = (password) => {
    let score = 0;
    if (!password) return "Too short";
    if (password.length >= 8) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[a-z]/.test(password)) score++;
    if (/[0-9]/.test(password)) score++;
    if (/[^A-Za-z0-9]/.test(password)) score++;
    if (score <= 2) return "Weak";
    if (score === 3 || score === 4) return "Medium";
    return "Strong";
  };

  const handlePasswordSubmit = (values, { setSubmitting }) => {
    const reqObj = { password: values.password, email: forgotEmail };
    dispatch(
      reqToResetPassword({
        data: reqObj,
        onSuccess: (res) => {
          // notify(res?.data?.message, "success");
          dispatch(setLoginSource(null));
          setOpen(true);
          // dispatch(logout());
          // navigate(routes.signUp);
        },
        onFailure: () => {
          setSubmitting(false);
        },
      })
    );
  };

  const [showPassword, setShowPassword] = useState(false);
  const [showRestPassword, setShowRestPassword] = useState(false);

  return (
    <div className="signup-page bg-white">
      <div className="container">
        <div className="signup-container h-screen flex items-center flex-wrap relative">
          <div className="py-3 w-full lg:w-1/2 h-full hidden lg:flex">
            <div className="signup-left w-full h-full lg:flex items-start justify-between flex-col  bg-blue relative rounded-[30px]">
              <img
                src={LoginLeftBg}
                alt="LoginLeftBg"
                className="absolute left-0 top-0 z-0"
              />
              <img
                src={LoginRightTopBg}
                alt="LoginRightTopBg"
                className="absolute right-0 top-0 z-0"
              />
              <img
                src={LoginRightBottomBg}
                alt="LoginRightBottomBg"
                className="absolute right-0 bottom-0 z-0"
              />
              <div className="signUpText flex flex-col gap-5 ps-[45px] pt-[35px]">
                <img src={signLogo} className="max-w-[168px]" alt="" />
              </div>
              <img
                src={forgotPassword1}
                alt="reset"
                className="mb-0 object-contain w-auto h-[70%] z-0"
              />
            </div>
          </div>

          <div
            className={`signup-right overflow-auto w-full lg:w-1/2 mx-auto md:px-[70px] h-full py-10 flex items-center justify-center flex-col px-4 relative`}
          >
            <div className="backArrow absolute md:left-[70px] top-10 left-4">
              <button
                type="button"
                aria-label="Go back"
                onClick={() => navigate(-1)}
                className="cursor-pointer"
              >
                {BackArrowIcon}
              </button>
            </div>
            <div className="signup-right-title pb-[53px]">
              <div
                className=" w-[84px] h-[84px]
    border-[16px] border-[#E3EAF9]
    rounded-full
    flex items-center justify-center
    mx-auto mb-[20px]"
              >
                {emailIcon}
              </div>
              <h1 className="font-roboto mb-2 text-center text-black  inner-title">
                Reset password
              </h1>
              <p className="text-p mb-0 text-gray w-80 text-center">
                Create a new password for {forgotEmail}. Please never share it
                with anyone.
              </p>
            </div>

            <div className={` w-full lg:max-w-lg space-y-4 pb-5`}>
              <Formik
                initialValues={initialValues}
                validationSchema={passwordSchema}
                onSubmit={handlePasswordSubmit}
              >
                {({ values, isSubmitting }) => {
                  const strength = getPasswordStrength(values.password);
                  return (
                    <Form className="w-full signin-form space-y-4 h-full flex flex-col">
                      <div>
                        <label>Create Password</label>
                        <div className="relative">
                          <Field
                            type={showPassword ? "text" : "password"}
                            name="password"
                            placeholder="Enter Password"
                            className="w-full pr-10 border rounded px-3 py-2"
                          />
                          <div
                            className="absolute right-3 top-[70%] transform -translate-y-1/2 cursor-pointer"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? EyeShowIcon : EyeHideIcon}
                          </div>
                        </div>
                        <ErrorMessage
                          name="password"
                          component="div"
                          className="text-red-500 text-sm"
                        />
                      </div>

                      <div>
                        <label>Re-Enter Password</label>
                        <div className="relative">
                          <Field
                            type={showRestPassword ? "text" : "password"}
                            name="confirmPassword"
                            placeholder="Re-Enter Password"
                            className="w-full pr-10 border rounded px-3 py-2"
                          />
                          <div
                            className="absolute right-3 top-[70%] transform -translate-y-1/2 cursor-pointer"
                            onClick={() =>
                              setShowRestPassword(!showRestPassword)
                            }
                          >
                            {showRestPassword ? EyeShowIcon : EyeHideIcon}
                          </div>
                        </div>
                        <ErrorMessage
                          name="confirmPassword"
                          component="div"
                          className="text-red-500 text-sm"
                        />
                      </div>
                      <div className="!mt-[24px] !mb-[53px]">
                        <label className="!flex items-center justify-start gap-2 cursor-pointer select-none">
                          <Field
                            type="checkbox"
                            name="rememberMe"
                            className="!w-4 h-4 border rounded"
                          />
                          <span className="whitespace-nowrap text-[#787891]">
                            Remember me
                          </span>
                        </label>
                      </div>
                      <ul className="text-left space-y-3 list-tag">
                        <li
                          className={
                            values.password.length >= 8
                              ? "list-tick text-[#54AA19]"
                              : "list-none text-[#888076]"
                          }
                        >
                          {/* {checkboxChecked}        */}
                          <span
                            className={
                              values.password.length >= 8
                                ? "text-[#54AA19]"
                                : "text-[#888076]"
                            }
                          >
                            Must contain at least 8 characters
                          </span>
                        </li>
                        <li
                          className={
                            /[a-z]/.test(values.password)
                              ? "list-tick text-[#54AA19]"
                              : "list-none text-[#888076]"
                          }
                        >
                          <span
                            className={
                              /[a-z]/.test(values.password)
                                ? "text-[#54AA19]"
                                : "text-[#888076]"
                            }
                          >
                            One Lowercase letter
                          </span>
                        </li>
                        <li
                          className={
                            /[A-Z]/.test(values.password)
                              ? "list-tick text-[#54AA19]"
                              : "list-none text-[#888076]"
                          }
                        >
                          <span
                            className={
                              /[A-Z]/.test(values.password)
                                ? "text-[#54AA19]"
                                : "text-[#888076]"
                            }
                          >
                            One Uppercase letter
                          </span>
                        </li>
                        <li
                          className={
                            /[0-9]/.test(values.password) &&
                            /[^A-Za-z0-9]/.test(values.password)
                              ? "list-tick text-[#54AA19]"
                              : "list-none text-[#888076]"
                          }
                        >
                          <span
                            className={
                              /[0-9]/.test(values.password) &&
                              /[^A-Za-z0-9]/.test(values.password)
                                ? "text-[#54AA19]"
                                : "text-[#888076]"
                            }
                          >
                            Including a number and a special character.
                          </span>
                        </li>
                        {/* <li
                          className={`text-sm ${
                            strength === "Strong"
                              ? "list-tick text-[#54AA19]"
                              : "list-none text-[#888076]"
                          }`}
                        >
                          Strength: {strength}
                        </li> */}
                      </ul>

                      <div className="pt-5">
                        <button
                          type="submit"
                          className="btn-yellow mx-auto"
                          disabled={isSubmitting}
                        >
                          Submit{" "}
                        </button>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>

      {open && (
        <Modal
          show={open}
          onClose={() => setOpen(false)}
          onConfirm={() => {
            dispatch(logout());
            navigate(routes.login);
          }}
          title="Password Updated Successfully"
          description="Your new password is active. You can now sign in securely and continue managing your workspace."
          image={Celebration}
          confirmText="Proceed to Sign In"
          proceedRoute={routes.login}
        />
      )}
    </div>
  );
};

export default ResetPassword;
